/**
 * Role Validation Schemas
 * Shared Zod validators for role-related operations
 */
import { z } from "zod";
export const createRoleSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().optional(),
    permissionIds: z.array(z.number()).optional(),
});
export const updateRoleSchema = createRoleSchema.partial();
//# sourceMappingURL=role.schema.js.map